module.exports = __webpack_public_path__ + "img/photo3_8.5e3c6888.jpg";